import React, { useState } from "react";
import { ProyectsComponent } from "../components";
import listaProyectos from "../data/listaProyectos";
import { listar } from "../utils/funciones";

function ProyectsContainer({ itemsArray }) {
  const nPag = Math.ceil(listaProyectos.length / 2);
  const [pag, setPag] = useState(1);
  const [lista, setLista] = useState(listar(pag, listaProyectos));
  const [animar, setAnimar] = useState(false);
  return (
    <ProyectsComponent
      props={{
        cantPag: nPag,
        list: lista,
        completeList: listaProyectos,
        fnPag: setPag,
        fnList: setLista,
        listar: listar,
        animacion: { bol: animar, fn: setAnimar },
      }}
    />
  );
}

export default ProyectsContainer;
